import './page_index.styl';

import React from 'react';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import getLocale from '@ali/brokkoli/lib/utils/get_locale';
import { route } from '@ali/react-router-lite';

import log from '@ali/log';
// const { SHARE_TYPE: { FB, WHATSAPP, CLIENT }, share } = require('@ali/bucket/components/share');
// import { BG } from '../constants.js';
import HomePage from '@ali/broccoli-cmp-pageindex';
import Header from '@ali/broccoli-cmp-header';
import resource from '@ali/resource';
import getConfig from '@ali/cuttle-config';

const pg = 'index';

class PageIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // leftStart: 220,
    };
  }
  componentWillMount() {
  }

  componentDidMount() {
    log.logVisit(pg);
    // this.forbitScroll();
    this.setBtnWidth();
  }

  setBtnWidth() {
    const imgUrl = getLocale('page_index.btn_bg');
    resource.loadEssentialResource([ imgUrl ], () => {
      const $btnImg = resource.getResource(imgUrl);
      const btnImgWidth = $btnImg.width;
      const leftStart = this.computeLeftStart(btnImgWidth);
      console.log(leftStart);
      this.setState({
        leftStart,
      }, () => {
        console.log(this.state.leftStart);
      });
    });
  }

  computeLeftStart(btnImgWidth) {
    if (!btnImgWidth) {
      return 0;
    }
    return (640 - btnImgWidth) / 2;
  }

  handleClickStart = () => {
    log.logClick('act_start', { pg });
    route.goHash('answer');
  }

  render() {
    console.log('RED', this.state.leftStart);
    const { leftStart } = this.state;
    const { descColor, linkRule, imgCdnPrefix, bottomStart } = this.props;
    const changeLanguageIcon = `${imgCdnPrefix}lange-icon.png`;
    const shareBtnIcon = `${imgCdnPrefix}share-icon.png`;
    const ruleBtnIcon = `${imgCdnPrefix}rule-icon.png`;
    console.log(React.version);
    return (
      <HomePage
        slogan={'page_index.page_bg'}
        startBtn={'page_index.btn_bg'}
        leftStart={leftStart}
        start={this.handleClickStart}
        bottomStart={bottomStart}>
        <Header
          pg={'index'}
          shareScene={'share_page'}
          linkRule={linkRule}
          shareBtnStyle={{
            background: `url(${shareBtnIcon}) no-repeat`,
          }}
          ruleBtnStyle={{
            background: `url(${ruleBtnIcon}) no-repeat`,
          }}
          langeConf={{
            bgColor: '#032048',
            selectBgColor: '#0159ce',
            tabListKey: 'lange_switch.lange',
            btnBgImg: changeLanguageIcon,
            left: 82,
            top: 22,
            btnStyle: { width: '.051rem', height: '.051rem' },
            listStyle: { top: '0.06rem', left: '20%', width: '0.1rem' },
          }}/>
          <p className="desc" style={{ color: descColor }}>{getLocale('page_index.tips')}</p>
      </HomePage>
      // <div>111</div>
    );
  }
  _act() {
    route.goHash('result');
  }

}

const mapStateToProps = state => {
  const conf = state.init.conf.pageIndex;
  const commonConfig = state.init.conf.commonConfig;
  return {
    descColor: conf.descColor,
    imgCdnPrefix: commonConfig.imgCdnPrefix,
    bottomStart: conf.bottomStart,
    linkRule: commonConfig.rule,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(PageIndex);
